import styled from 'styled-components';
import { Button } from '@sketch/components';

const StyledButton = styled(Button) `
  flex: 1;
`;

export { StyledButton };
